import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, CardHeader, Typography } from "@mui/material";
import "../../Styles/strategy.css";
import DistributionChart from "../charts/DistributionChart";
import { imageMapping } from "../../icons/Strategy/Icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { GetStrategyTable } from "../../redux/Actions/strategyService";
import Loader from "../../Loader";
import Icon from "react-crypto-icons";

function Strategies({ strategy }) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { strategyData, loading } = useSelector((state) => state.strategy);
  const [strategies, setStrategies] = useState([]);

  useEffect(() => {
    dispatch(GetStrategyTable());
  }, []);
  useEffect(() => {
    if (!strategy) {
      setStrategies(strategyData);
    } else {
      const filterStrategies = strategyData?.filter(
        (i) => i?.custodian?.name?.toLowerCase() == strategy
      );

      setStrategies(filterStrategies);
    }
  }, [strategyData, strategy]);
  return (
    <>
      <Grid item xs={12} sx={{ paddingTop: 1 }}>
        {loading ? (
          <Loader />
        ) : strategies?.length > 0 ? (
          <Grid container spacing={2}>
            {strategies?.map((values, keys) => (
              <Grid item key={values.id} xs={4} sm={12} md={3}>
                <Card
                  sx={{ minWidth: 250 }}
                  className="Maincard"
                  onClick={() => {
                    navigate(`/performance/${values?.id}`);
                  }}
                >
                  <CardContent>
                    <center>
                      <CardHeader
                        title={values?.strategyName}
                        style={{ fontSize: "14px", marginTop: "5px" }}
                      />
                      <DistributionChart
                        proportion={values?.strategyBreakups}
                      />
                      <Typography
                        variant="h7"
                        component="div"
                        className="strategy"
                      >
                        Overall Fund Return
                      </Typography>
                      <Typography variant="h5" component="div">
                        230.99%
                      </Typography>
                      <div
                        style={{
                          marginTop: "7px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {values?.strategyBreakups &&
                          values?.strategyBreakups
                            ?.slice(0, 4)
                            ?.map((val, id) => {
                              const imageName =
                                val?.asset?.symbol?.toLowerCase();
                              return (
                                <div
                                  className="iconcard"
                                  style={{ marginRight: "5px" }}
                                >
                                  <center>
                                    <Icon name={imageName} size={20} />
                                  </center>
                                </div>
                              );
                            })}
                      </div>
                    </center>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography
            variant="h6"
            style={{ textAlign: "center", marginTop: "20px" }}
          >
            No strategy data exists.
          </Typography>
        )}
      </Grid>
    </>
  );
}

export default Strategies;
